import { AI_SERVICE_HOST } from '../config';

/**
 * Client for the local AI service (see ai-service/README.md).
 *
 * The Anthropic key lives in that service, never here — CRA inlines every
 * REACT_APP_* value into the published bundle. No auth header is sent because
 * the service is bound to localhost.
 */

/** Thrown for every failure so callers can branch on `code`. */
export class AiServiceError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'AiServiceError';
    this.code = code;
  }
}

const SERVICE_DOWN =
  'AI service is not running. Start it with `npm start` in the ai-service folder.';

async function post(path, body) {
  let response;

  try {
    response = await fetch(`${AI_SERVICE_HOST}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch (error) {
    // fetch only rejects on a network-level failure, which here means the
    // service is not listening.
    throw new AiServiceError(SERVICE_DOWN, 'service_unavailable');
  }

  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const detail = payload && payload.error ? payload.error : {};
    throw new AiServiceError(
      detail.message || `AI service returned ${response.status}.`,
      detail.code || 'http_error',
    );
  }

  return payload;
}

export function postBriefToFilters(brief, campaign) {
  return post('/api/ai/brief-to-filters', { brief, campaign });
}

export function postRankCreators(brief, candidates, filters) {
  return post('/api/ai/rank-creators', { brief, candidates, filters });
}

export function postPlanPreview(brief, selection, budget, filters) {
  return post('/api/ai/plan-preview', { brief, selection, budget, filters });
}
